// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - AI Area
export var AIGetRouteQueryTask;
(function (AIGetRouteQueryTask) {
    AIGetRouteQueryTask["answer"] = "answer";
    AIGetRouteQueryTask["answerWithStream"] = "answerWithStream";
    AIGetRouteQueryTask["autocomplete"] = "autocomplete";
    AIGetRouteQueryTask["reindex"] = "reindex";
    AIGetRouteQueryTask["summarize"] = "summarize";
    AIGetRouteQueryTask["code"] = "code";
})(AIGetRouteQueryTask || (AIGetRouteQueryTask = {}));
export class AreaAI {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(dataCore) {
        this.dataCore = dataCore;
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - AI features
    /** Summarizes a prompt into a title. Response is not streamed.
     * @param from - Version identifier
     * @param text - Text to summarize
     * @param options - Summarization options
     * @returns Summarized title
     * @disclaimer This method will throw if the user is not authorized to use AI features (if you are reading this, you are not authorized).
     */
    async summarizeIntoTitle(from, text, options = {
        maxWordCount: 3,
        strategy: "noun",
    }) {
        return this.dataCore.aiSummarizeIntoTitle(from.workspaceId, from.designSystemId, from.versionId, text, options);
    }
    /** Populates Forge instance a code snippet from a prompt. Response is streamed.
     * @param from - Version identifier
     * @param projectId - Project identifier
     * @param participantId - Participant identifier
     * @param messageType - Message type
     * @param prompt - User prompt
     * @param options - Population options
     * @returns Populated code snippet
     * @disclaimer This method will throw if the user is not authorized to use AI features (if you are reading this, you are not authorized).
     */
    async aiCode(from, projectId, participantId, messageType, prompt, options) {
        return this.dataCore.aiCode(from.workspaceId, from.designSystemId, from.versionId, projectId, participantId, messageType, prompt, options);
    }
    /** Autocompletes a prompt into a full text. Response is not streamed.
     * @param from - Version identifier
     * @param textToComplete - Text to autocomplete
     * @param options - Autocomplete options
     * @returns Autocompleted text
     * @disclaimer This method will throw if the user is not authorized to use AI features (if you are reading this, you are not authorized).
     */
    async autocompleteText(from, textToComplete, options = { maximumLength: 200, previousText: undefined, afterText: undefined }) {
        return this.dataCore.aiAutocompleteText(from.workspaceId, from.designSystemId, from.versionId, textToComplete, options);
    }
    /** Answers question based on the data of design system in natural language. This method is non-streaming.
     * @param from - Version identifier
     * @param prompt - Question to answer
     * @param options - Answering options
     * @returns Answer to the question
     * @disclaimer This method will throw if the user is not authorized to use AI features (if you are reading this, you are not authorized).
     */
    async answer(from, prompt, options = {
        persona: "developer",
        scope: "all",
        density: "full",
    }) {
        return this.dataCore.aiAnswer(from.workspaceId, from.designSystemId, from.versionId, prompt, options);
    }
    /** Answers question based on the data of design system in natural language. This method streams answer.
     * @param from - Version identifier
     * @param prompt - Question to answer
     * @param options - Answering options
     * @returns Answer to the question
     * @disclaimer This method will throw if the user is not authorized to use AI features (if you are reading this, you are not authorized).
     */
    async answerAsStream(from, prompt, options = {
        persona: "developer",
        scope: "all",
        density: "full",
    }) {
        return this.dataCore.aiAnswerAsStream(from.workspaceId, from.designSystemId, from.versionId, prompt, options);
    }
    /** Indexes or reindexes a design system to prepare it for QA engine
     * @param from - Version identifier
     * @returns Indexing status
     * @disclaimer This method will throw if the user is not authorized to use AI features (if you are reading this, you are not authorized).
     */
    async rebuildAnswerIndex(from) {
        return this.dataCore.aiRebuildAnswerIndex(from.workspaceId, from.designSystemId, from.versionId);
    }
    /** Temp: Retrieves dynamic URL for all AI tasks
     * @param task - Which task to retrieve URL for
     * @returns Url for the task
     */
    async executableTaskUrl(task) {
        return this.dataCore.executableTaskUrl(task);
    }
}
